<template>
  <div style="background: linear-gradient(90deg, rgba(29,151,208,1) 25%, rgba(0,14,112,1) 70%);">
    <hr />
    <footer class="container-fluid" data-bs-theme="dark">
      <div class="row text-center text-lg-start" style="margin-bottom: -20px;">
        <div class="col-lg-8">
          <div class="row">
            <div class="col-md-4">
              <div style="text-align: center;">
                <a :href="homeLink">
                  <img :src="require('@/assets/aogs2025/img/MMI_LOGO.png')" class="MMI-footerLogo">
                </a>
                <h6 class="MMI-footerTitle"><b>AOGS Secretariat</b></h6>
                <p class="MMI-footerText" style="margin-bottom: 0px;">
                  Website: <a class="MMI-footerLink" href="http://www.meetmatt.net/v5/public.asp?page=home.asp" target="_blank">www.meetmatt.net</a><br />
                  Email: <a class="MMI-footerLink" href="mailto:meetmatt@meetmatt.net" target="_blank">meetmatt@meetmatt.net</a>
                </p>
              </div>
            </div>
            <div class="col-md-4">
              <h6 class="MMI-footerTitle"><b>Information & Support</b></h6>
              <p class="MMI-footerText" style="margin-bottom: 0px;">
                <b>Exhibition & Sponsorship:</b> <a class="MMI-footerLink" href="mailto:geomeet@asiaoceania.org" target="_blank">geomeet@asiaoceania.org</a><br />
                <b>Scientific Program & Help Desk:</b> <a class="MMI-footerLink" href="mailto:info@asiaoceania.org" target="_blank">info@asiaoceania.org</a><br />
                <b>Society Business, Feedback & Complaints:</b> <a class="MMI-footerLink" href="mailto:admin@asiaoceania.org" target="_blank">admin@asiaoceania.org</a>
              </p>
            </div>
            <div class="col-md-4">
              <p class="MMI-footerText">
                Website: <a class="MMI-footerLink" href="https://www.asiaoceania.org/society/public.asp?page=home.asp" target="_blank">www.asiaoceania.org</a><br />
                Tel: (65) 6472 3108<br />
                Add: 1 Commonwealth Lane #06-23<br />
                ONE COMMONWEALTH, Singapore 149544
              </p>
              <p>
                <a href="https://twitter.com/i/flow/login?redirect_after_login=%2FAOGS_"><i class="fa-brands fa-square-x-twitter fa-2xl" style="color: white; margin: 5px;"></i></a>
                <a href="https://www.facebook.com/AsiaOceaniaGeosciencesSociety"><i class="fa-brands fa-square-facebook fa-2xl" style="color: white; margin: 5px;"></i></a>
                <a href="https://www.linkedin.com/in/asia-oceania-geosciences-society-37632a194/?originalSubdomain=sg"><i class="fa-brands fa-linkedin fa-2xl" style="color: white; margin: 5px;"></i></a>
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-4 mb-4">
          <div class="row">
            <div class="col-12 col-md-12">
              <h6 class="MMI-footerTitle"><b>Supported By</b></h6>
              <a style="text-decoration: none;">
                <img :src="require('@/assets/aogs2025/img/3 AOGS LOGO-01.png')" class="MMI-footerLogo1">
              </a>
              <p></p>
            </div>
            <div class="col-12 col-md-12">
              <div class="row">
                <div class="col-6 col-md-6">
                  <h6 class="MMI-footerTitle"><b>Legal</b></h6>
                  <ul class="nav flex-column MMI-footerText">
                    <li class="nav-item mb-2"><a href="#" class="MMI-footerLink">Privacy Policy</a></li>
                  </ul>
                </div>
                <div class="col-6 col-md-6">
                  <h6 class="MMI-footerTitle"><b>Credits</b></h6>
                  <ul class="nav flex-column MMI-footerText">
                    <li class="nav-item mb-2"><a href="#" class="MMI-footerLink">Freepik</a></li>
                    <li class="nav-item mb-2"><a href="#" class="MMI-footerLink">Unsplash</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <hr style="color: white;" />

        <div>
          <p class="MMI-footerText" style="text-align: center;">Copyright &copy; 2025. All Rights Reserved. Conference Managed by Meeting Matters International</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'CommonFooter',
  props: {
    homeLink: {
      type: String,
      default: 'public.asp_page=home.asp.html'
    }
  }
}
</script>

<style scoped>
/* Footer styles */
.MMI-footerLogo {
  height: 60px;
  width: auto;
  margin-bottom: 10px;
}

.MMI-footerLogo1 {
  height: 40px;
  width: auto;
  margin-bottom: 10px;
}

.MMI-footerTitle {
  color: white;
  font-size: 16px;
  margin-bottom: 10px;
}

.MMI-footerText {
  color: #ccc;
  font-size: 14px;
  line-height: 1.4;
}

.MMI-footerLink {
  color: #4CAF50;
  text-decoration: none;
}

.MMI-footerLink:hover {
  color: #66BB6A;
}
</style>

